import React, { useEffect, useState } from 'react';

export default function StoryRevealAnimation({ onComplete }) {
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), 1800);
    const hideTimer = setTimeout(() => {
      setVisible(false);
      if (onComplete) onComplete();
    }, 2500);
    return () => { clearTimeout(fadeTimer); clearTimeout(hideTimer); };
  }, [onComplete]);

  if (!visible) return null;

  const stars = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    left: `${5 + (i * 4.7) % 90}%`,
    top: `${10 + (i * 7.3) % 80}%`,
    size: `${12 + (i * 3) % 16}px`,
    delay: `${(i * 0.12) % 1.2}s`,
    duration: `${0.8 + (i * 0.07) % 0.6}s`,
  }));

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'linear-gradient(135deg, #1a0a3d 0%, #2d1b69 50%, #0f0b1e 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      opacity: fadeOut ? 0 : 1,
      transition: 'opacity 0.7s ease',
      pointerEvents: fadeOut ? 'none' : 'all',
    }}>
      <style>{`
        @keyframes starFloat { 0%{transform:scale(0) rotate(0deg);opacity:0} 50%{opacity:1} 100%{transform:scale(1.4) rotate(180deg);opacity:0} }
        @keyframes moonBounce { 0%,100%{transform:scale(1) translateY(0)} 50%{transform:scale(1.1) translateY(-12px)} }
        @keyframes shimmerText { 0%,100%{opacity:0.7} 50%{opacity:1} }
      `}</style>

      {/* Stars */}
      {stars.map(s => (
        <div key={s.id} style={{
          position: 'absolute', left: s.left, top: s.top,
          width: s.size, height: s.size, fontSize: s.size,
          animation: `starFloat ${s.duration} ${s.delay} ease-in-out infinite`,
        }}>✨</div>
      ))}

      {/* Moon */}
      <div style={{ fontSize: '72px', animation: 'moonBounce 2s ease-in-out infinite', marginBottom: '20px' }}>🌙</div>

      <h2 style={{
        color: '#e8d5ff', fontFamily: "'Fredoka One',cursive", fontSize: '28px',
        margin: '0 0 8px', animation: 'shimmerText 1.5s ease-in-out infinite',
      }}>
        Your story is ready…
      </h2>
      <p style={{ color: '#b0a0d0', fontSize: '15px', margin: 0 }}>Dreamy Bedtime ✨</p>

      {/* Progress bar */}
      <div style={{ width: '200px', height: '4px', background: 'rgba(255,255,255,0.15)', borderRadius: '2px', marginTop: '24px', overflow: 'hidden' }}>
        <div style={{
          height: '100%', background: 'linear-gradient(90deg,#9b6fe8,#f9c74f)',
          borderRadius: '2px', animation: 'none',
          width: fadeOut ? '100%' : '70%',
          transition: 'width 1.5s ease',
        }} />
      </div>
    </div>
  );
}
